export default __webpack_public_path__ + "static/media/pic1.4fe5ddff.jpg";